import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import 'slick-carousel'

export default component((node, ctx) => {
  
    var slider = $(node.querySelector('.js-slider'));

    slider.slick({
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: jQuery(node.querySelector('.js-arrow-right')),
        prevArrow: jQuery(node.querySelector('.js-arrow-left')),
        infinite: false,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });
    
})
